var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6326 21.3855H22.4476L22.0276 20.9805C23.4976 19.2705 24.3826 17.0505 24.3826 14.6355C24.3826 9.2505 20.0176 4.8855 14.6326 4.8855C9.24757 4.8855 4.88257 9.2505 4.88257 14.6355C4.88257 20.0205 9.24757 24.3855 14.6326 24.3855C17.0476 24.3855 19.2676 23.5005 20.9776 22.0305L21.3826 22.4505V23.6355L28.8826 31.1205L31.1176 28.8855L23.6326 21.3855ZM14.6326 21.3855C10.8976 21.3855 7.88257 18.3705 7.88257 14.6355C7.88257 10.9005 10.8976 7.8855 14.6326 7.8855C18.3676 7.8855 21.3826 10.9005 21.3826 14.6355C21.3826 18.3705 18.3676 21.3855 14.6326 21.3855Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7d36f38c7605d3ac7d117a3a53472c55.svg";
export { ForwardRef as ReactComponent };